import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames/bind';

import VendorsSlider from 'components/widgets/VendorsSlider';
import ImagePromo from 'components/promos/ImagePromo';

import { isExist } from 'utils/helpers.js';

import styles from './styles.styl';

const cx = cn.bind(styles);

function VendorsSidebarPhone({ promos, partners }) {
  return (
    <div className={cx('VendorsSidebarPhone')}>
      {isExist(partners, 'items') && (
        <VendorsSlider className={cx('VendorsSidebarPhone__widget')} {...partners} />
      )}

      <div className={cx('VendorsSidebarPhone__promos')}>
        <ImagePromo
          gtmId="Image_bner_Mid1"
          id={promos[0]}
          className={cx('VendorsSidebarPhone__promosItem')}
        />
        <ImagePromo
          gtmId="Image_bner_Mid2"
          id={promos[1]}
          className={cx('VendorsSidebarPhone__promosItem')}
        />
      </div>
    </div>
  );
}

VendorsSidebarPhone.propTypes = {
  promos: PropTypes.array,
  partners: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default VendorsSidebarPhone;
